import createIcon from '../../createIcon';

/**
 * @component @name RunCircle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xMy41IDZDMTQuMDUgNiAxNC41IDYuNDUgMTQuNSA3QzE0LjUgNy41NSAxNC4wNSA4IDEzLjUgOEMxMi45NSA4IDEyLjUgNy41NSAxMi41IDdDMTIuNSA2LjQ1IDEyLjk1IDYgMTMuNSA2Wk0xNiAxMkMxNS4zIDEyIDEzLjk5IDExLjQ2IDEzLjA5IDEwLjI0TDEyLjY4IDEyLjU5TDE0IDE0LjAzVjE4SDEzVjE0LjQyTDExLjg5IDEzLjIxTDExLjM3IDE1Ljg1TDcuNiAxNS4wOEw3LjggMTQuMUwxMC41OCAxNC42N0wxMS41NCA5Ljc4TDEwIDEwLjM1VjEySDlWOS42NUwxMi4yOCA4LjQ0QzEyLjc3IDguMjYgMTMuMzEgOC41IDEzLjU0IDguOTdDMTQuMzcgMTAuNjcgMTUuNTkgMTEgMTYgMTFWMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RunCircle = createIcon('RunCircle', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.5 6C14.05 6 14.5 6.45 14.5 7C14.5 7.55 14.05 8 13.5 8C12.95 8 12.5 7.55 12.5 7C12.5 6.45 12.95 6 13.5 6ZM16 12C15.3 12 13.99 11.46 13.09 10.24L12.68 12.59L14 14.03V18H13V14.42L11.89 13.21L11.37 15.85L7.6 15.08L7.8 14.1L10.58 14.67L11.54 9.78L10 10.35V12H9V9.65L12.28 8.44C12.77 8.26 13.31 8.5 13.54 8.97C14.37 10.67 15.59 11 16 11V12Z',
      key: '1eh6yt',
    },
  ],
]);

export default RunCircle;
